<template>
    <div class="chat_wrap">
        <pop-request-mtm :show="Mtm" :isMobile="true" @accept="joinmtm" @close="mtmpopClose" title="1:1 채팅 신청">
          <template v-slot:from_user>[ {{mtmUserNic}} ]</template>  
        </pop-request-mtm>  
        <div v-if="viewList">
            <chatroom-list />
        </div>
       
        <div class="chatBase">
            <div class="chatHeader" v-if="!room_id.includes('mtm')">
              <div class="room_out" @click="routeback()">
                <span class="mark"><font-awesome-icon :icon="['fas', 'angle-left']" /></span>
                채팅로비 
              </div>
              <div class="open_menu">
                <div @click="open_side_menu()"><font-awesome-icon :icon="['fas', 'bars']" /></div>
              </div>
            </div>
            <chat-room-header :room_id="room_id" :isMobile="true" @chatroom-info="getRoomInfo" :joincount="users.length" v-if="!room_id.includes('mtm')"/>
            
            <chat-body
            :messages="messages"
            :admin_messages="admin_messages"
            :isChat="isChat"
            :ownerId ="owner_userId"
            :chat_roomId="chat_roomId"
            :ckstate="setstate"
            :mtm_join="mtm_join"
            :chatroomInfo="chatroomInfo"
            @sendmessage="sendMessage"
            @initstate="initstate"
            @mtm-close="mtmClose"
            />
        </div>
    </div>
    
    <div id="side_menu" class="sidemenu">               
      <div  class="aside_top">
        <div class="btn_close" @click="open_side_menu()">닫기</div>
       
      </div>
      <div class="aside_body">        
        <chatroom-aside :chatroomInfo="chatroomInfo" :room_id="room_id" :connectusers="users"/>
      </div>       
      <div class="aside_bottom">
        <a href="javascript:void(0)" @click="routeback()"> 채팅방 나가기</a>
      </div>       
    </div>
    <div v-if='view_sidemenu' @click="open_side_menu()" class="backdrop"></div>
    <base-dialog :show="ckConnect" @close="confirm">
      다른곳에서 접속 하셨습니다.
    </base-dialog>
</template>

<script>
import ChatRoomHeader from "@/components/chat/parts/ChatRoomHeader";
import ChatBody from "@/mobile/components/chat/parts/ChatBody";
import ChatroomList from '@/components/chat/ChatroomListWidget';
import PopRequestMtm from "@/components/ui/PopRequestMtm";
import ChatroomAside from "@/mobile/components/chat/parts/ChatroomAside"
import { socketio } from '@/components/mixins/socketio.js';
import { auth } from '@/components/mixins/auth.js';
export default {
  name: 'ChatBase',
  props: ['room_id', 'viewList','roomout','owner_userId'],
  data() {
    return {
      username: "",     
      test: this.$store.state.serverDomain,
      otherConnect: false,    
      view_sidemenu: false,   
      chatroom: "",
      chatroomid: "",
      chatroomInfo: "",
      outsignal: "",      
      nowRoom:true,// 방생성후 라우터 2중으로 표시되는 문제
      mtm_join:""
        
   
    };
  },
  mixins:[socketio,auth]
  ,
  components: {  
    ChatRoomHeader,  
    ChatBody,
    ChatroomList,
    PopRequestMtm,
    ChatroomAside
  },
  // created(){
  //       this.$store.dispatch('tryLogin');
  // },
 
  mounted() {
    // this.username = '손님_'+this.makeid(5) ;
    // console.log(this.username);
    console.log("test", this.test);
    this.currentUser = this.$store.getters.currentUser;
    this.userIP = this.$store.getters.userIP;
    this.mtm_join ='';
    //테스트 메세지
    // this.socket.emit('createMessage',{
    //     from : "WDJ",
    //     text : "Whats going on!"
    // }, function(message){
    //     console.log('서버응답:', message)
    // })
  }, 
  //method 시작=========================================================================
  methods: {
    //chatbody에서 close받아서 값을 초기화
    mtmClose(){
      this.mtm_join ='';
    },
    routeback()
    {
      //this.$router.push('/m/home');
      this.socket.disconnect();
      this.$router.go(-1);            
    },
    confirm() {
      this.otherConnect = false;
    },   
    updatesetting(type){
      
      if(type === "initmessage"){
        //메세지 초기화       
        if(this.messages.length >0){
          this.messages =[]; 
          this.messages.push({from:'Admin', text:'화면 초기화', color:'red'});       
        }     
      }
    },
    open_side_menu(){
      document.querySelector('#side_menu').classList.toggle('view_sidemenu'); 
      this.view_sidemenu = !this.view_sidemenu;
    },
    getRoomInfo(data) {
      //console.log('ChatRoom에서 데이터',data);
      this.chatroomInfo = data;
    },
   

    //랜덤 id 생성
    // makeid(length) {
    //     var result = '';
    //     var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    //     var charactersLength = characters.length;
    //     for ( var i = 0; i < length; i++ ) {
    //         result += characters.charAt(Math.floor(Math.random() * charactersLength));
    //     }
    //     return result;
    // },
  },
  //method 끝=========================================================================
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    user() {
      return this.$store.getters.currentUser;
    },
    ckConnect() {
      return this.otherConnect;
    },
    ckroomout(){
        //console.log('룸아웃이벤트',this.roomout);
        return this.roomout;
    },
    chat_roomId(){
        
        if(this.room_id !== 'm1' && !this.room_id.includes('mtm'))
        {
          return 'room_'+this.room_id;
        }else{
          return this.room_id;
        }            
    },
   
  },
  watch:{
      ckroomout(roomid)
      {
          //alert('확인'+roomid);
        if(roomid)
        {
           this.routeback(); 
        }
      },
      user(currentUser){
        if(currentUser.id ===0)
        {          
          this.routeback(); 
        }
      }

  },
  // updated() {
  //   this.username = this.$store.getters.currentUser.id;
  //   console.log("유저네임", this.username);
  // },
};
</script>

<style lang="scss" scoped>

@keyframes example {
  from   {background-color: rgba(0, 0, 0, 0);} 
  to {background-color: rgba(0, 0, 0, 0.5);}
}

.sidemenu{
  background:#fff;
  height: 100vh;
  width:70%;
  position: fixed;
  right:0px;
  top:0px;
  background:#fff;  
  transform: translateX(100%);
  transition: transform 0.3s ease-in 0s;
  display: flex;
  flex-direction: column;   
  z-index: 19;    
  .aside_top{
    background: rgb(29, 97, 223);
    height:43px;
    padding:10px;
    display: flex;
    justify-content: space-between;
    .btn_close{
      display: inline-block;
      cursor: pointer;
      width:19px;
      height:19px;
      background-image:url(../../../assets/imgs/sign.png);
      background-position: -81px 0;
      background-size: 150px auto;
      text-indent: -9999px;   
    }
    .title{
      font-family: nanumgothic;
      font-size:12px;
      font-weight: bold;
      color:white;
      padding-top:3px;
    }
  }
  .aside_body{
    height: 100vh;
  }
  .aside_bottom{
    height: 50px;
    background: rgb(245, 245, 245);
    border-top:1px solid rgb(230, 230, 230);
    display: flex;
    align-items: center;
    padding-left:10px;
  }
}
.view_sidemenu{
  transform: translateX(0); 
  transition: transform 0.2s ease-in 0s;   
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.chat_wrap{
    display:flex;
    height: 100%;
    .chatHeader{
      background: rgb(29, 97, 223);
      height: 50px;
      color:#fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: naumgothic;
      padding:0 10px;
      .room_out{
        display: flex;
        align-items: center;
        .mark{font-size:20px;padding-right:10px;}
      }
      .open_menu{
        font-size:20px;
      }
    }
    .chatBase {
        flex:1 1 auto;
        display: flex;
        flex-direction: column;
        background: #fff;
    }
}

</style>
